module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "frontmatter",
      "id": "rbk4glo"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4glo#bk4glo"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#bk4ch1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#bk4ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#bk4ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch4#bk4ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#bk4ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#bk4ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#bk4ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#bk4ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rbk4ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch9#bk4ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rbk4bm1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4bm1#bk4bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rbk4ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ack#bk4ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rre3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Recipes3#re3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes from "), _c('i', [_vm._v("Building Faith")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Recipes3#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mud Hen Bars")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Recipes_sec4#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overnight Amish Potato Salad")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rexe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_excerpt#exe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Excerpt from "), _c('i', [_vm._v("A Cup Half Full")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "radcard"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Also#adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Kathleen Fuller")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rbk4ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ata#bk4ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": ""
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/9780718023676_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/text/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/9780718023676_Book_4ch1"
    }
  }, [_vm._v("Chapter 1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "page-list",
      "hidden": "hidden",
      "xmlns:epub": "http://www.idpf.org/2007/ops"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Also#page_i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Also#page_ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Titlepage#page_iv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Titlepage#page_v",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("v")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Copyright#page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vi")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/nav#page_vii"
    }
  }, [_vm._v("vii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ded#page_318"
    }
  }, [_vm._v("318")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ded#page_319"
    }
  }, [_vm._v("319")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4glo#page_320"
    }
  }, [_vm._v("320")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4glo#page_321"
    }
  }, [_vm._v("321")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_322"
    }
  }, [_vm._v("322")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_323"
    }
  }, [_vm._v("323")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_324"
    }
  }, [_vm._v("324")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_325"
    }
  }, [_vm._v("325")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_326"
    }
  }, [_vm._v("326")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_327"
    }
  }, [_vm._v("327")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_328"
    }
  }, [_vm._v("328")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_329"
    }
  }, [_vm._v("329")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_330"
    }
  }, [_vm._v("330")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_331"
    }
  }, [_vm._v("331")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch1#page_332"
    }
  }, [_vm._v("332")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("333")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("334")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("335")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("336")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("337")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("338")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("339")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("340")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch2#page_341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("341")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("342")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("343")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("344")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("345")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("346")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("347")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("348")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch3#page_349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("349")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch4#page_350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("350")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch4#page_351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("351")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch4#page_352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("352")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch4#page_353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("353")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch4#page_354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("354")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("355")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("356")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("357")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("358")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("359")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("360")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("361")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("362")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("363")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch5#page_364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("364")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("365")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("366")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("367")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("368")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("369")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("370")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("371")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("372")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch6#page_373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("373")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#page_374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("374")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#page_375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("375")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#page_376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("376")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#page_377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("377")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#page_378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("378")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#page_379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("379")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch7#page_380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("380")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("381")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("382")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("383")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("384")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("385")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("386")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("387")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch8#page_388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("388")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch9#page_389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("389")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch9#page_390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("390")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch9#page_391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("391")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch9#page_392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("392")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ch9#page_393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("393")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4bm1#page_394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("394")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ack#page_395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("395")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4back#page_396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("396")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Book_4ata#page_397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("397")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Recipes3#page_405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("405")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Recipes_sec4#page_406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("406")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Recipes_sec4#page_407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("407")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718023676_Recipes_sec4#page_408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("408")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ebf9b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/nav.vue
// module id = 63
// module chunks = 0